import { render, staticRenderFns } from "./view_product.vue?vue&type=template&id=373d4a11"
import script from "./view_product.vue?vue&type=script&lang=js"
export * from "./view_product.vue?vue&type=script&lang=js"
import style0 from "./view_product.vue?vue&type=style&index=0&id=373d4a11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports